import { Announcement } from "@cryptors/api-client";
import { Chip, Stack, Typography } from "@mui/material";
import { useShow } from "@refinedev/core";
import { Show, TextFieldComponent as TextField } from "@refinedev/mui";

import { getTranslation } from "@/utils/translation";

export const AnnouncementShow = () => {
  const { query } = useShow<Announcement>({ resource: "announcements" });
  const announcement = query.data?.data;
  const expired =
    !!announcement?.endDate &&
    new Date(announcement.endDate).getTime() <= Date.now();

  return (
    <Show isLoading={query.isLoading}>
      <Stack gap={1}>
        <Typography variant="body1" fontWeight="bold">
          Statut
        </Typography>
        <div>
          <Chip
            size="small"
            color={
              !announcement?.enabled
                ? "default"
                : expired
                  ? "warning"
                  : "success"
            }
            label={
              !announcement?.enabled
                ? "Désactivée"
                : expired
                  ? "Expirée"
                  : "Active"
            }
          />
        </div>
        <Typography variant="body1" fontWeight="bold">
          Titre
        </Typography>
        <TextField
          value={
            getTranslation(announcement?.titleTranslation, "fr")?.value ?? ""
          }
        />
        <Typography variant="body1" fontWeight="bold">
          Message
        </Typography>
        <TextField
          value={
            getTranslation(announcement?.messageTranslation, "fr")?.value ?? ""
          }
        />
        <Typography variant="body1" fontWeight="bold">
          Date de fin
        </Typography>
        <TextField
          value={
            announcement?.endDate
              ? new Date(announcement.endDate).toLocaleString("fr-FR")
              : "Aucune"
          }
        />
      </Stack>
    </Show>
  );
};
